import { usePostCompleteGuideOneMutation } from "../../services/apiSlice";
import SingleView from "./Views/SingleView";
import CarouselView from "./Views/CarouselView";

const STORAGE_KEY = "has_seen_onboarding_v1";

const OnboardingModal = ({ onClose, config }) => {
  const [postCompleteGuideOne] = usePostCompleteGuideOneMutation();

  if (!config) return null;

  const handleFinish = async () => {
    try {
      await postCompleteGuideOne().unwrap();
    } catch (error) {
      console.error("Failed to complete guide:", error);
    }
    localStorage.setItem(STORAGE_KEY, "true");
    if (onClose) onClose();
  };

  return (
    <>
      {config.type === "SINGLE" ? (
        <SingleView data={config} onFinish={handleFinish} />
      ) : (
        <CarouselView data={config} onFinish={handleFinish} />
      )}
    </>
  );
};

export default OnboardingModal;
